"use strict";
/*!
 * Copyright 2012 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Catalog = void 0;
const IonSystemSymbolTable_1 = require("./IonSystemSymbolTable");
function byVersion(x, y) {
    return x.version - y.version;
}
/**
 * A catalog holds available shared symbol tables and always includes the system symbol table.
 * @see https://amzn.github.io/ion-docs/docs/symbols.html#the-catalog
 */
class Catalog {
    /** Creates a catalog containing only the system symbol table. */
    constructor() {
        this.symbolTables = {};
        this.add((0, IonSystemSymbolTable_1.getSystemSymbolTable)());
    }
    /** Adds a new shared symbol table to this catalog. */
    add(symbolTable) {
        if (symbolTable.name === undefined || symbolTable.name === null) {
            throw new Error("SymbolTable name must be defined.");
        }
        const versions = this.symbolTables[symbolTable.name];
        if (versions === undefined) {
            this.symbolTables[symbolTable.name] = [];
        }
        this.symbolTables[symbolTable.name][symbolTable.version] = symbolTable;
    }
    /**
     * Returns a symbol table by name and version.
     *
     * @return The symbol table or `null` if it does not exist in the {Catalog}.
     */
    getVersion(name, version) {
        const tables = this.symbolTables[name];
        if (!tables) {
            return null;
        }
        let table = tables[version];
        if (!table) {
            table = tables[tables.length];
        }
        return table ? table : null;
    }
    /**
     * Retrieves the latest version of a symbol table by name.
     *
     * @return The symbol table or `null` if it does not exist in the {Catalog}.
     */
    getTable(name) {
        const versions = this.symbolTables[name];
        if (versions === undefined) {
            return null;
        }
        return versions[versions.length - 1];
    }
}
exports.Catalog = Catalog;
